var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.46994 12.3766C2.88574 10.2643 4.39289 7.25 7.03323 7.25H27.9668C30.6071 7.25 32.1143 10.2643 30.5301 12.3766V12.3766C29.3746 13.9172 28.75 15.791 28.75 17.7168V29.75C28.75 33.8921 25.3921 37.25 21.25 37.25H13.75C9.60787 37.25 6.25 33.8921 6.25 29.75V17.7168C6.25 15.791 5.6254 13.9172 4.46994 12.3766V12.3766Z",
    stroke: "#ED1C00",
    strokeWidth: 2.8125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 27.875L21.25 16.625",
    stroke: "#ED1C00",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.875L13.75 16.625",
    stroke: "#ED1C00",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 7.25L23.9797 4.18915C23.4693 2.65786 22.0363 1.625 20.4222 1.625H14.5778C12.9637 1.625 11.5307 2.65786 11.0203 4.18915L10 7.25",
    stroke: "#ED1C00",
    strokeWidth: 2.8125,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgTrash);
export default __webpack_public_path__ + "static/media/bg-trash.ab0c819958b661049e20771b6ac758fb.svg";
export { ForwardRef as ReactComponent };